module.exports = ".mat-dialog-content>*{width:800px;margin:0 auto}.mat-table{display:table;width:100%}"